import PropTypes from "prop-types";

import Button from "../common/Button";
import NewToolTip from "../common/New-ToolTip";

const ClinicalsFeatureCard = ({
  title = "",
  buttonText = "",
  onButtonClick = () => {},
  disabled = false,
  icon = null,
}) => {
  const tooltipId = `clinicals-coming-soon-${title.replace(/\s+/g, "-").toLowerCase()}`;

  return (
    <div className="flex h-[415px] w-full flex-col justify-between rounded-[10px] bg-teal-60 p-5">
      <div className="relative flex h-[78px] w-[78px] shrink-0 items-center justify-center overflow-hidden rounded-[10px] bg-REELTeal">
        {icon}
      </div>
      <div className="flex flex-col gap-10 rounded-md border border-white bg-[rgba(250,250,250,0.8)] p-2.5">
        <p className="text-[28px] font-semibold leading-[35px] text-teal-300">
          {title}
        </p>
        <div data-tooltip-id={disabled ? tooltipId : ""}>
          <Button
            type="primary"
            text={buttonText}
            onClick={onButtonClick}
            disabled={disabled}
            className="w-full !px-8 !py-3.5 disabled:!opacity-100"
          />
        </div>
        {disabled && (
          <NewToolTip
            id={tooltipId}
            render={() => (
              <div className="!bg-gray-20 max-w-[460px] p-2 text-body-sm text-teal-300">
                Coming Soon
              </div>
            )}
            place="top"
          />
        )}
      </div>
    </div>
  );
};

ClinicalsFeatureCard.propTypes = {
  title: PropTypes.string,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  disabled: PropTypes.bool,
  icon: PropTypes.node,
};

export default ClinicalsFeatureCard;
